/**
 * AnnouncementLinkService
 * Service for managing announcement links
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for announcement link CRUD operations
 */
export class AnnouncementLinkService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AnnouncementLinkService.DEFAULT_SERVICE_PATH,
            basePath: AnnouncementLinkService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get all links for a specific announcement
     * GET /api/announcement-links/by-announcement/{announcementId}
     * @param announcementId - Announcement ID
     * @returns Array of announcement links
     */
    async getByAnnouncementId(announcementId) {
        const response = await this.getByAnnouncementIdRaw(announcementId);
        return response.data ?? [];
    }
    /**
     * Get all links for a specific announcement (raw response)
     * @param announcementId - Announcement ID
     */
    getByAnnouncementIdRaw(announcementId) {
        const url = this.buildUrl(`by-announcement/${announcementId}`);
        return this.http.get(url);
    }
}
AnnouncementLinkService.DEFAULT_SERVICE_PATH = 'announcements';
AnnouncementLinkService.BASE_PATH = 'api/announcement-links';
//# sourceMappingURL=AnnouncementLinkService.js.map